import { IInsightWidget } from '@jumpstart/core';
import { WidgetType } from '@jumpstart/core/dist/schemas/insight/insight';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { headerCase } from 'change-case';
import { FieldArray } from 'formik';
import React from 'react';
import ContentField from './ContentField';
import { IValidation } from './utils';
import WidgetMetaField from './WidgetMetaField';

export interface IWidgetField {
  values: any;
  widget: IInsightWidget;
  index: number;
  classes: any;
  arrayHelpers: any;
  handleChange: any;
  setFieldValue: any;
  touched: any;
  validation: IValidation;
}

export default function WidgetField(props: IWidgetField) {
  const {index, values, widget, classes, arrayHelpers, handleChange, setFieldValue, validation, touched} = props;

  return (
    <Grid key={`widgets[${index}]`} container direction="column" style={{ marginBottom: 12 }}>
      <Grid container direction="row" wrap="nowrap" justifyContent="space-between"
            sx={classes.input}>
        <Typography variant="caption">Widget {index + 1}</Typography>
        <Button
          startIcon={<CloseIcon/>}
          variant="contained"
          onClick={() => arrayHelpers.remove(index)}
          color="secondary"
        >
          Remove Widget {index + 1}
        </Button>
      </Grid>

      <TextField
        sx={classes.input}
        key={`widgets[${index}].widget`}
        id={`widgets[${index}].widget`}
        name={`widgets[${index}].widget`}
        label="Widget Type"
        value={widget.widget}
        onChange={handleChange}
        select
        variant="outlined"
      >
        {
          [...Object.keys(WidgetType)]
            .map((key: string) => <MenuItem
                key={`widgets[${index}].widget.${key}`}
                value={key}
              >
                {headerCase(key)}
              </MenuItem>
            )
        }
      </TextField>

      <ContentField
        name={`widgets[${index}].title`}
        id={`widgets[${index}].title`}
        key={`widgets[${index}].title`}
        label="Widget Title"
        helperText={`Defaults to "Essential"`}
        defaultValue={widget.title ? widget.title : 'Essential'}
        onBlur={handleChange}
        sx={classes.input}
        variant="outlined"
        validation={validation}
        touched={touched.widgets}
        multiline
      />

      <ContentField
        name={`widgets[${index}].purpose`}
        id={`widgets[${index}].purpose`}
        key={`widgets[${index}].purpose`}
        label="Widget Purpose"
        defaultValue={widget.purpose}
        onBlur={handleChange}
        sx={classes.input}
        variant="outlined"
        placeholder="Purpose"
        validation={validation}
        touched={touched.widgets}
        multiline
      />

      <WidgetMetaField
        classes={classes}
        index={index}
        widget={widget}
        handleChange={handleChange}
        setFieldValue={setFieldValue}
      />

      <Grid container style={{padding: '0 24px'}}>

      <Typography variant="body2" style={{ width: '100%', textAlign: 'center' }}>Widget
        Requirements</Typography>
      <FieldArray
        name={`widgets[${index}].requirements`}>
        {(arrayRequirementsHelpers) =>
          <React.Fragment>
            {(widget.requirements ? widget.requirements : [])
              .map((requirement: string, requirementIndex: number) =>
                <ContentField
                  name={`widgets[${index}].requirements[${requirementIndex}]`}
                  key={`widgets[${index}].requirements[${requirementIndex}]`}
                  id={`widgets[${index}].requirements[${requirementIndex}]`}
                  label={`Requirement ${requirementIndex}`}
                  defaultValue={requirement}
                  onBlur={handleChange}
                  sx={classes.input}
                  variant="outlined"
                  placeholder="Requirement"
                  multiline
                  touched={!!touched.widgets}
                  validation={validation}
                  InputProps={
                    {
                      additionalEndAdornments:
                        <IconButton
                          size="small"
                          onClick={() => arrayRequirementsHelpers.remove(index)}
                        >
                          <CloseIcon/>
                        </IconButton>
                    }
                  }
                />
              )}
            <Grid item container direction="column" justifyContent="center" alignItems="center"
                  sx={classes.input}>
              <Button
                startIcon={<AddIcon/>}
                style={{ width: 250 }}
                onClick={() => arrayRequirementsHelpers.push('')}
              >
                Add Requirement Note
              </Button>
            </Grid>
          </React.Fragment>
        }
      </FieldArray>
      </Grid>

    </Grid>

  )
}
